import * as Yup from "yup";
import { REQUIRED_FIELD } from "../../../common/validation";
export const defaultCandidateFields = {
  name: "",
  registration_no: "",
  error_code: "",
  reason: "",
};
export const candidateSchema = Yup.object().shape({
  name: REQUIRED_FIELD,
  registration_no: REQUIRED_FIELD,
  error_code: REQUIRED_FIELD,
});
